import React from "react";
import { useForm } from "react-hook-form";
import { Notification } from "../common/Notification";
import { sendRequest } from "../../util/httpClient";
const MedicalIdFraudProtectionForm = (props: any) => {
    const { register, handleSubmit, errors } = useForm({
        mode: "onBlur",
    });
    const closeDialog = () => {
        props.closeDialog();
    };
    const getFraudProtectionPdf = (data: any) => {
        const requestBody = {
            "medical-fraud-protection-form": {
                "insurance-provider": data.insuranceProvider,
                "group-id": data.groupId,
                "member-id": data.memberId,
                "provider-address": data.providerAddress,
                "provider-city": data.providerCity,
                "provider-state": data.providerState,
                "provider-zip": data.providerZip,
            },
        };
        sendRequest("POST", `api/medicalIDFraudProtection/medicalIDFraudProtectionForm`, requestBody, {}, true)
            .then((data: any) => {
                if (data.status === 200) {
                    data.blob({ type: "application/pdf" }).then((blob: any) => {
                        let url = window.URL.createObjectURL(blob);
                        let a = document.createElement("a");
                        a.href = url;
                        a.download = "MedicalFraudProtection.pdf";
                        a.click();
                        closeDialog();
                    });
                    Notification({
                        type: "success",
                        title: "Medical Fraud Protection",
                        message: "Medical fraud protection pdf downloaded successfully.",
                    });
                } else {
                    throw new Error(data.statusText);
                }
            })
            .catch(function (error) {
                closeDialog();
                Notification({
                    type: "error",
                    message: "We are unable to generate the PDF file at this time. Please try again later.",
                    title: "Medical Fraud Protection",
                    duration: 0,
                });
            });
    };

    const onSubmit = (data: any) => {
        getFraudProtectionPdf(data);
    };

    return (
        <React.Fragment>
            <form onSubmit={handleSubmit(onSubmit)}>
                <div className="dialog-header">
                    <div className="dialog-icon">
                        <em className="las la-edit"></em>
                    </div>
                    <h1>Medical Fraud Protection</h1>
                </div>
                <div className="dialog-body">
                    <div className={errors["groupId"] ? "form-row status-error" : "form-row"}>
                        <div className="form-label">
                            <label htmlFor="groupId">
                                Group ID{" "}
                                <span className="required" title="Mandatory">
                                    *
                                </span>
                            </label>
                        </div>
                        <div className="form-input">
                            <input
                                ref={register({ required: true, pattern: /^[a-zA-Z0-9]+$/ })}
                                type="text"
                                name="groupId"
                                className="inputbox"
                                id="groupId"
                                placeholder="ex.1e23d423er334"
                                maxLength={30}
                                aria-required="true"
                            />
                        </div>
                        {{ ...errors["groupId"] }.type === "required" && <span className="form-error">Group id is required</span>}
                        {{ ...errors["groupId"] }.type === "pattern" && (
                            <span className="form-error">Invalid format. Group id can only include numbers and letters.</span>
                        )}
                    </div>

                    <div className={errors["memberId"] ? "form-row status-error" : "form-row"}>
                        <div className="form-label">
                            <label htmlFor="memberId">
                                Member ID{" "}
                                <span className="required" title="Mandatory">
                                    *
                                </span>
                            </label>
                        </div>
                        <div className="form-input">
                            <input
                                ref={register({ required: true, pattern: /^[a-zA-Z0-9]+$/, minLength: 4 })}
                                type="text"
                                name="memberId"
                                className="inputbox"
                                id="memberId"
                                placeholder="ex.1e23d423er334"
                                aria-required="true"
                            />
                        </div>
                        {{ ...errors["memberId"] }.type === "required" && (
                            <span role="alert" className="form-error">
                                Member Id is required
                            </span>
                        )}
                        {{ ...errors["memberId"] }.type === "pattern" && (
                            <span role="alert" className="form-error">
                                Invalid format. Member Id can only include numbers and letters.
                            </span>
                        )}
                        {!!errors["memberId"] && !!errors["memberId"] && errors["memberId"]!.type == "minLength" && (
                            <span className="form-error">Invalid format. Member Id must be a minimum of 4 characters in length.</span>
                        )}
                    </div>

                    <div className={errors["insuranceProvider"] ? "form-row status-error" : "form-row"}>
                        <div className="form-label">
                            <label htmlFor="insurance-id">
                                Insurance Provider{" "}
                                <span className="required" title="Mandatory">
                                    *
                                </span>
                            </label>
                        </div>
                        <div className="form-input">
                            <input
                                ref={register({ required: true, pattern: /^[a-zA-Z\s]+$/ })}
                                type="text"
                                name="insuranceProvider"
                                className="inputbox"
                                id="insurance-id"
                                placeholder="ex. Insurance Provider"
                                aria-required="true"
                            />
                        </div>
                        {{ ...errors["insuranceProvider"] }.type === "required" && <span className="form-error">Insurance Provider is required</span>}
                        {{ ...errors["insuranceProvider"] }.type === "pattern" && (
                            <span className="form-error"> Invalid format. Insurance Provider can only include letters and spaces.</span>
                        )}
                    </div>

                    <div className={errors["providerAddress"] ? "form-row status-error" : "form-row"}>
                        <div className="form-label">
                            <label htmlFor="providerAddress">
                                Provider Address{" "}
                                <span className="required" title="Mandatory">
                                    *
                                </span>
                            </label>
                        </div>
                        <div className="form-input">
                            <input
                                ref={register({ required: true, pattern: /^[a-zA-Z0-9-#,/.\s]+$/, maxLength: 100 })}
                                type="text"
                                name="providerAddress"
                                className="inputbox"
                                id="providerAddress"
                                placeholder="ex. Street Name, 10224"
                                aria-required="true"
                            />
                        </div>
                        {{ ...errors["providerAddress"] }.type === "required" && <span className="form-error">Provider Address is required</span>}
                        {{ ...errors["providerAddress"] }.type === "pattern" && (
                            <span className="form-error">
                                Invalid format. Address Street Number and Name can only include letters, numbers, and the special characters: #-/,.
                            </span>
                        )}
                        {{ ...errors["providerAddress"] }.type === "maxLength" && (
                            <span className="form-error">Invalid format. Please limit the adress length to the 100 characters including spaces.</span>
                        )}
                    </div>

                    <div className={errors["providerCity"] ? "form-row status-error" : "form-row"}>
                        <div className="form-label">
                            <label htmlFor="providerCity">
                                Provider City{" "}
                                <span className="required" title="Mandatory">
                                    *
                                </span>
                            </label>
                        </div>
                        <div className="form-input">
                            <input
                                ref={register({
                                    required: true,
                                    pattern: /^[a-zA-Z.\s]+$/,
                                })}
                                type="text"
                                name="providerCity"
                                className="inputbox"
                                id="providerCity"
                                placeholder="ex. Los Angeles"
                                aria-required="true"
                            />
                        </div>
                        {{ ...errors["providerCity"] }.type === "required" && <span className="form-error">Provider City is required</span>}
                        {{ ...errors["providerCity"] }.type === "pattern" && (
                            <span className="form-error">Invalid Format. City can only include letters, spaces, and the special character: .</span>
                        )}
                    </div>

                    <div className={errors["providerState"] ? "form-row status-error" : "form-row"}>
                        <div className="form-label">
                            <label htmlFor="providerState">
                                Provider State{" "}
                                <span className="required" title="Mandatory">
                                    *
                                </span>
                            </label>
                        </div>
                        <div className="form-input">
                            <input
                                ref={register({ required: true, pattern: /^[a-zA-Z.\s]+$/ })}
                                type="text"
                                name="providerState"
                                className="inputbox"
                                id="providerState"
                                placeholder="ex. California"
                                aria-required="true"
                            />
                        </div>
                        {{ ...errors["providerState"] }.type === "required" && <span className="form-error">Provider State is required</span>}
                        {{ ...errors["providerState"] }.type === "pattern" && <span className="form-error">Invalid format. State can only include letters</span>}
                    </div>

                    <div className={errors["providerZip"] ? "form-row status-error" : "form-row"}>
                        <div className="form-label">
                            <label htmlFor="providerZip-code">
                                Provider Zip Code{" "}
                                <span className="required" title="Mandatory">
                                    *
                                </span>
                            </label>
                        </div>
                        <div className="form-input">
                            <input
                                ref={register({
                                    required: true,
                                    pattern: /(^(?!0{5})(\d{5})(?!-?0{4})(|-\d{4})?$)/,
                                })}
                                maxLength={10}
                                type="text"
                                name="providerZip"
                                className="inputbox"
                                id="providerZip-code"
                                placeholder="ex. 01234 or 01234-5678"
                                aria-required="true"
                            />
                        </div>
                        {{ ...errors["providerZip"] }.type === "required" && <span className="form-error">Provider zip is required</span>}
                        {{ ...errors["providerZip"] }.type === "pattern" && (
                            <span className="form-error">Invalid format. Zip Code must be entered in either of the two formats: 01234 or 01234-5678</span>
                        )}
                    </div>
                </div>
                <div className="dialog-footer">
                    <div className="row between-xs">
                        <div className="col-xs col-no-gutter flex-grow-null">
                            <button
                                type="button"
                                className="btn-default btn-link btn-no-padding"
                                aria-label="Close this dialog window"
                                data-a11y-dialog-hide="true"
                                onClick={() => {
                                    closeDialog();
                                    window.addToDataLayer({ event: "Cancel Medical Id Fraud Protection Data Submission" });
                                }}
                            >
                                <span className="btn-text">Cancel</span>
                            </button>
                        </div>
                        <div className="col-xs col-no-gutter flex-grow-null">
                            <button
                                type="submit"
                                className="btn-default btn-primary"
                                aria-label="Close this dialog window"
                                disabled={!!Object.keys(errors).length}
                                onClick={() => window.addToDataLayer({ event: "Submit Medical Id Fraud Protection Data" })}
                            >
                                <span className="btn-text">Save</span>
                            </button>
                        </div>
                    </div>
                </div>
            </form>
        </React.Fragment>
    );
};

export default MedicalIdFraudProtectionForm;
